export default window.WebSocket
